import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormControl, Input } from '@material-ui/core';
import { useField } from 'formik';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
// import { HideIcon, PreviewIcon } from '../Images/Icons';
import HideIcon from '../../../assets/images/Icon/eyeInvisible.png';
import PreviewIcon from '../../../assets/images/Icon/eyeVisible.png';

const styles = makeStyles((theme) => ({
    rootFormControl: (props) => ({
        direction: props.rtl ? 'rtl' : props.dynamic ? 'ltr' : 'inherit',
        textAlign: 'start',
        width: props.width === '100%' || props.dynamic ? '100%' : 'auto',
        paddingLeft:
            props.width === '100%' || props.dynamic ? '0' : props.rootRtl ? '30px' : 'auto',
        paddingRight:
            props.width === '100%' || props.dynamic ? '0' : props.rootRtl ? 'auto' : '30px',
        [theme.breakpoints.down(1025)]: {
            paddingLeft: '0px',
            paddingRight: '0px'
        },
        position: 'relative',
        '&:hover div:nth-child(3)': {
            display: 'block'
        }
    }),
    label: {
        paddingBottom: '8px',
        color: '#767676',
        fontFamily: 'mainFont !important'
    },
    input: (props) => ({
        border: props.border ? props.border : 'solid 1px #bbbbbb',
        backgroundColor: props.bgColor ? props.bgColor : '#ffffff',
        // borderRadius: props.isMobile ? '4px' : '9px',
        paddingRight: '10px',
        paddingLeft: '10px',
        color: '#3d454a',
        lineHeight: '1.67em',
        height: '1.67em',
        width: props.dynamic ? '100%' : props.width ? props.width : '148px',
        '&:focus-within': {
            border: 'solid 1px #1b90fa'
        },
        [theme.breakpoints.down(1025)]: {
            width: '100%'
        },
        '&[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '&::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        textAlign: props.alignment || 'start',
        unicodeBidi: 'plaintext'
    }),
    errorContainer: (props) => ({
        padding: '3px 7px',
        fontSize: '0.9em',
        color: 'red',
        minHeight: props.dynamic ? '10px' : '26px'
    }),
    showingPassword: {
        position: 'absolute',
        top: '38%',
        right: '7px',
        display: 'none',
        '& img': {
            width: '24px',
            height: '24px',
            cursor: 'pointer'
        }
    }
}));
function ClinicInput(props) {
    const { autoFocus = false, dir, alignment, isPassword = false } = props;
    const { lang } = useContext(LanguageContext);
    const { messages } = useContext(MessagesContext);
    const classes = styles({ ...props, rootRtl: lang === 'fa', alignment });
    const [field, meta] = useField(props);
    const [type, setType] = useState(props.type || 'text');

    const inputRef = useRef(null);

    useEffect(() => {
        const handleWheel = (e) => e.preventDefault();
        inputRef.current.addEventListener('wheel', handleWheel);

        return () => {
            inputRef.current.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <FormControl classes={{ root: `${classes.rootFormControl} ${props.customClasses}` }}>
            {props.dynamic ? (
                <label
                    dangerouslySetInnerHTML={{ __html: props.label }}
                    className={classes.label}
                    htmlFor={props.id || props.name}
                ></label>
            ) : (
                props.label && (
                    <label
                        className={classes.label}
                        htmlFor={props.id || props.name}
                        id={props.name}
                    >
                        {props.label}
                        {props.optionalToUse && (
                            <span style={{ color: '#bbbbbb' }}>
                                &nbsp;
                                <span>(</span>
                                <span>{messages.optional}</span>
                                <span>)</span>
                            </span>
                        )}
                    </label>
                )
            )}

            <Input
                classes={{
                    root: classes.inputRoot,
                    input: classes.input
                }}
                inputProps={{ 'data-testid': `${props.name}`, 'aria-labelledby': `${props.name}` }}
                autoFocus={autoFocus}
                {...field}
                {...props}
                autoComplete="divoonamKerdi"
                ref={inputRef}
                dir={dir}
                type={type}
            />
            {isPassword ? (
                <div className={classes.showingPassword}>
                    {type === 'password' ? (
                        <img src={PreviewIcon} onClick={() => setType('text')} />
                    ) : (
                        <img src={HideIcon} onClick={() => setType('password')} />
                    )}
                </div>
            ) : null}

            <div className={classes.errorContainer}>
                {meta.touched && meta.error ? <span>{meta.error}</span> : null}
            </div>
        </FormControl>
    );
}
export default ClinicInput;
ClinicInput.propTypes = {
    id: PropTypes.any,
    name: PropTypes.string,
    label: PropTypes.string,
    dynamic: PropTypes.any,
    optionalToUse: PropTypes.bool,
    customClasses: PropTypes.string,
    autoFocus: PropTypes.bool,
    dir: PropTypes.string,
    type: PropTypes.string,
    isPassword: PropTypes.bool,
    alignment: PropTypes.string
};
